// Firebase configuration file
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAiNqquW3l8RuQB_w8eps9othHXJdj4-y4",
  authDomain: "traveleasy-f76f4.firebaseapp.com",
  projectId: "traveleasy-f76f4",
  storageBucket: "traveleasy-f76f4.appspot.com", // Corrected from .firebasestorage.app
  messagingSenderId: "1073628440310",
  appId: "1:1073628440310:web:b0b512453e6d84b93d2ed7",
  measurementId: "G-RRC7RYKVPG"
};

// Public VAPID key for web push notifications
export const vapidKey = "BFW-MrqnFRQvtw6eTOuqpyTmvfrs6focyb80YzKuxCGQkCD6K9ACx4eintwjTIiqpnaZf2RUh2UYzuzs7wKf8Ug";

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Analytics is intentionally not initialized: it is unused, and its internal
// Installations call logs failures (e.g. invalid API key) via console.error,
// which we cannot catch.
let messaging: Messaging | null = null;

// Initialize messaging only in browser environment
if (typeof window !== 'undefined') {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase messaging not supported in this environment', error);
  }
}

export { messaging };

// Function to request notification permission and get FCM token
export const requestPermission = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted' && messaging) {
      // Get FCM token
      const currentToken = await getToken(messaging, {
        vapidKey: vapidKey,
      });
      
      if (currentToken) {
        return currentToken;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.warn('Error requesting notification permission:', error);
    return null;
  }
};

// Function to listen for foreground messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (messaging) {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    } else {
      resolve(null);
    }
  });